import { RenderType } from '@intelligence/pages/_config/topchartsInterface';

export const defaultMetrictableApiParams = {
  order: 'desc',
  ratio_type: 0,
  search_by_name: '',
  data_method: '',
  unified_ids: [],
  page: 1,
  // page_size: 100,
  page_size: 50,
  genre_source: 'iegg',
  iegg_genre_req: [],
  company: [],
  start_release_time: '',
  end_release_time: '',
  segment: 'All',
  start_date: '',
  end_date: '',
  filter_ids: [],
  steam_tag: [],
  game_mode: [],
  region_type: 'market',
  regions: ['global'],
  date_type: 'monthly',
};

export const defaultMetrictableChartsDownloadApiParams = {
  entity_type: 'pc',
  order: 'desc',
  unified_ids: [''],
  device: ['PlayStation', 'Xbox', 'Nintendo'],
  segment: 'All',
  start_date: '',
  end_date: '',
  order_metric: 'pcu',
  order_source: 'steamcharts',
  topchart_name: '',
  region_type: 'market',
  regions: ['global'],
  date_type: 'daily',
  source_metrics: {
    steamcharts: ['pcu', 'acu'],
    // vginsights: ['steamfollowers', 'steamreviews'],
    vginsights: ['steamreviews'],
    mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
    gsd: ['gsd_digitalUnits', 'gsd_physicalUnits', 'gsd_digitalRevenue', 'gsd_physicalRevenue'],
    npd: ['revenue', 'physical_units'],
  },
};

export const defaultSteamChartsDownloadApiParams = {
  entity_type: 'pc',
  order: 'desc',
  ratio_type: 0,
  search_by_name: '',
  data_method: '',
  unified_ids: [],
  page: 1,
  page_size: 100,
  genre_source: 'iegg',
  iegg_genre_req: [],
  company: [],
  start_release_time: '',
  end_release_time: '',
  segment: 'All',
  start_date: '',
  end_date: '',
  filter_ids: [],
  order_metric: 'est_revenue',
  order_source: 'vginsights',
  source_metrics: {
    vginsights: [
      'est_revenue',
      'est_units',
      'est_price_time',
      'est_price',
      'weighted_price',
      'playtime',
      'followers',
      'players_by_country',
    ],
  },
  topchart_name: 'Steam Sales',
  region_type: 'market',
  regions: ['global'],
  date_type: 'daily',
  order_device: '',
};

export const defaultMobileChartsDownloadApiParams = {
  entity_type: 'mobile',
  metrics: ['dau', 'revenue', 'download', 'arpu'],
  order_metric: 'dau',
  order: 'desc',
  page: 1,
  page_size: 100,
  region_type: 'market',
  regions: ['global'],
  data_sources: ['appannie', 'sensortower'],
  order_source: 'appannie',
  platforms: ['appstore', 'googleplay'],
  date_type: 'daily',
  start_date: '',
  end_date: '',
  game_code: [''],
  segment: 'all',
  b_data_brain: 1,
  topcharts_name: 'active users',
};

export const defaultNewzooChartsDownloadApiParams = {
  entity_type: 'pc',
  order: 'desc',
  ratio_type: 0,
  search_by_name: '',
  data_method: '',
  unified_ids: [''],
  page: 1,
  page_size: 100,
  genre_source: 'iegg',
  iegg_genre_req: [],
  company: [],
  start_release_time: '',
  end_release_time: '',
  segment: 'All',
  start_date: '2023-12-01',
  end_date: '2024-05-31',
  filter_ids: [],
  order_metric: 'mau',
  order_source: 'newzoo',
  source_metrics: {
    newzoo: ['mau'],
    newzoo_weight: ['acquisition'],
  },
  topchart_name: 'MAU',
  region_type: 'market',
  regions: ['global'],
  date_type: 'monthly',
  order_device: '',
};

export const defaultStreamingChartsDownloadApiParams = {
  order_metric: 'hoursWatched',
  order: 'desc',
  app_ids: [''],
  page: 1,
  page_size: 100,
  platform: ['twitch', 'ytg', 'facebook'],
  start_date: '',
  end_date: '',
  period: 'daily',
  check_metric: 'hoursWatched',
  genre_source: 'iegg',
  iegg_genre_req: [],
  company: [],
  release_start_date: '',
  release_end_date: '',
  gameCode: [],
  game_type: 'all',
};
export const defaultMetaScore = {
  value: 'meta_score',
  text: 'dbi_metric_metacritic_global',
  dataSource: 'metacritic',
  width: 300,
  width_cn: 300,
  renderType: RenderType.METACRITIC_SCORE,
  category: 'storeRating',
  categoryNameEN: 'Store Rating',
  categoryNameCN: '商店评分',
  info: 'dbi_info_store_rating_disabled_tips_global',
  categoryDisabledTipsLocaleKey: 'dbi_info_store_rating_disabled_tips_global',
  metricDisabledTipsLocaleKey: 'dbi_info_store_rating_disabled_tips_global',
};

export const steamTagsColumn = {
  metricKey: 'steam_tag',
  text: 'dbi_top_steam_tags',
  dataSource: 'steam',
  width: 300,
  width_cn: 300,
  isNoDropdown: true,
  renderType: RenderType.TAGS,
};

export const gameModeColumn = {
  metricKey: 'game_mode',
  text: 'dbi_top_game_mode',
  dataSource: 'steam',
  width: 300,
  width_cn: 300,
  isNoDropdown: true,
  renderType: RenderType.TAGS,
};

export const gameEngineColumn = {
  metricKey: 'game_engine',
  text: 'dbi_top_game_engine',
  dataSource: 'igdb',
  width: 150,
  width_cn: 150,
  isNoDropdown: true,
  renderType: RenderType.TAGS,
};

export const defaultMetacritic = {
  metacritic: ['meta_score'],
};
